import { bootstrapApplication } from '@angular/platform-browser';
import { initializeApp } from 'firebase/app';
import { environment } from '@env/environment';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { initOtelTracing } from '@core/utils/otel-trace.util';


initOtelTracing();
initializeApp(environment.firebaseConfig);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
